import { render, staticRenderFns } from "./inteRecord.vue?vue&type=template&id=3aa109fe"
import script from "./inteRecord.vue?vue&type=script&lang=js"
export * from "./inteRecord.vue?vue&type=script&lang=js"
import style0 from "./inteRecord.vue?vue&type=style&index=0&id=3aa109fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports